<template>
  <div class="config_main_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item" @click.native="configGoPreviousPageHandle">
          <img class="main_top_img" slot="topnavimg" src="~assets/img/topnav/zuofanhui.png" alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div v-if="$route.query.type === 'afterLogin'" slot="topimgtext">关于我们</div>
          <div v-else slot="topimgtext">更多</div>
        </top-nav-item>
        <!-- 已登录 -->
        <top-nav-item v-if="$route.query.type === 'afterLogin'" class="right_item"
          @click.native="configReturnContronBtnHandle">
          <img class="main_top_img" slot="topnavimg" src="~assets/img/topnav/shebei_home.png" alt />
        </top-nav-item>
        <!-- 未登录时 -->
        <top-nav-item v-else></top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <div class="about_page_warper">
          <div class="about_icon_img">
            <img :src="serveAboutData.logoUrl || transparentPlaceholder" alt />
          </div>

          <div class="text_jian_jie">{{ serveAboutData.introduce || ' ' }}</div>

          <div class="about_info">
            <div class="img_2weima_wraper">
              <template v-if="serveAboutData.wxPublicUrl">
                <img class="img_2weima" :src="serveAboutData.wxPublicUrl" alt />
                <div>知识公众号</div>
              </template>
              <template v-else>
                <!-- 占位用透明图和空文字，保持布局 -->
                <img class="img_2weima" :src="transparentPlaceholder" alt />
                <div style="visibility: hidden;">知识公众号</div>
              </template>
            </div>

            <div class="about_base_info">
              <!-- 官网 -->
              <div class="about_guan_wang_info">
                <template v-if="serveAboutData.website">
                  <span class="about_guan_wang_info_title">官网:</span>
                  <a class="about_guan_wang_info_a" :href="serveAboutData.website" target="_blank">{{
                    serveAboutData.website }}</a>
                </template>
                <template v-else>
                  <span class="about_guan_wang_info_title">&nbsp;</span>
                  <span class="about_guan_wang_info_a">&nbsp;</span>
                </template>
              </div>

              <!-- 电话 -->
              <div class="about_guan_wang_info">
                <template v-if="serveAboutData.landline">
                  <span class="about_guan_wang_info_title">电话:</span>
                  <span class="about_guan_wang_info_text">{{ serveAboutData.landline }}</span>
                </template>
                <template v-else>
                  <span class="about_guan_wang_info_title">&nbsp;</span>
                  <span class="about_guan_wang_info_text">&nbsp;</span>
                </template>
              </div>

              <!-- 邮箱（放最后） -->
              <div class="about_guan_wang_info">
                <template v-if="serveAboutData.mailbox">
                  <span class="about_guan_wang_info_title">邮箱:</span>
                  <span class="about_guan_wang_info_text">{{ serveAboutData.mailbox }}</span>
                </template>
                <template v-else>
                  <span class="about_guan_wang_info_title">&nbsp;</span>
                  <span class="about_guan_wang_info_text">&nbsp;</span>
                </template>
              </div>
            </div>

            <div class="img_2weima_wraper">
              <template v-if="serveAboutData.appUrl">
                <img class="img_2weima" :src="serveAboutData.appUrl" alt />
                <div>APP下载</div>
              </template>
              <template v-else>
                <img class="img_2weima" :src="transparentPlaceholder" alt />
                <div style="visibility: hidden;">APP下载</div>
              </template>
            </div>
          </div>

          <div class="about_gongsi_banquan">{{ serveAboutData.company || ' ' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
export default {
  data() {
    return {
      serveAboutData: {
        androidVersion: "",
        appUrl: "",
        company: "",
        introduce: "",
        iosVersion: "",
        landline: "",
        logoUrl: "",
        mailbox: "",
        phone: "",
        qq: "",
        website: "",
        wechat: "",
        wxPublicUrl: ""
      },
      transparentPlaceholder:
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", // 1x1透明图
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang
  },
  methods: {
    configGoPreviousPageHandle() {
      ///导航栏返回按钮
      if (this.$route.query.type !== 'afterLogin') {
        this.$router.replace(this.$store.getters.getToken ? '/controlpage' : '/login');
        return;
      }
      this.$router.back();
    },
    configReturnContronBtnHandle() {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath);
    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    /// 获取关于页面数据 接口，获取数据
    let token = null;
    if (this.$route.query.type === 'afterLogin') {
      token = this.$store.state.token
    }

    this.$request({
      method: "post",
      authMode: this.$route.query.type === 'afterLogin' ? 'authenticated' : 'anonymous',
      url: "/config/findAppAbout",
      data: {
        token: token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveAboutData = res.data.data; ////拿到服务器返回的数据结果

          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style>
.about_page_warper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  width: 100%;
  height: 100%;

  justify-content: flex-end;
  align-items: center;
}

.about_icon_img img {
  margin: 10px 0px;
  width: 120px;
  height: 120px;
}

.text_jian_jie {
  width: 80%;

  /* 首行缩进两个空格 */
  text-indent: 2em;
}

.about_info {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 120px;
}

.about_guan_wang_info_title {
  margin-right: 3px;
}

.img_2weima_wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img_2weima {
  width: 160px;
  height: 160px;
}

.about_gongsi_banquan {
  position: fixed;
  bottom: 10px;
}
</style>
